/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated.js';
import { compareDependencies } from './dependenciesCompare.generated.js';
import { divideDependencies } from './dependenciesDivide.generated.js';
import { partitionSelectDependencies } from './dependenciesPartitionSelect.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMedian } from '../../factoriesAny.js';
export var medianDependencies = {
  addDependencies,
  compareDependencies,
  divideDependencies,
  partitionSelectDependencies,
  typedDependencies,
  createMedian
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMedian.generated.js
// module id = 552
// module chunks = 2